module.exports = __webpack_public_path__ + "static/media/mehinvest_03.58ff2e90.png";